import React__default from 'react';
import { n as noop } from './utils-9ef11656.js';
var Context = /*#__PURE__*/React__default.createContext({
  opened: '',
  setOpened: noop
});
var Consumer = Context.Consumer;
var Provider = Context.Provider;
export { Consumer as C, Provider as P };